/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_DiagramInputs */

const en_mk_publish_diagram = /** @type {(inputs: Mk_Publish_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App publishing workflow`)
};

const id_mk_publish_diagram = /** @type {(inputs: Mk_Publish_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alur penerbitan aplikasi`)
};

/**
* | output |
* | --- |
* | "App publishing workflow" |
*
* @param {Mk_Publish_DiagramInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_diagram = /** @type {((inputs?: Mk_Publish_DiagramInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_DiagramInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_diagram(inputs)
	return en_mk_publish_diagram(inputs)
});